import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { combineLatest, of } from 'rxjs';
import { catchError, filter, map, switchMap, take } from 'rxjs/operators';
import { StateFacade as OverviewFacade } from '../../facades/state.facade';
import { ErrorConstant, PLACE_HOLDER, SECTION_NAME } from '../../models';
import { DataLayerAnalyticsService } from '../../services/analytics/data-layer.service';
import { SnapshotService } from '../../services/api/snapshot.service';
import * as OverviewActions from '../actions/api.actions';

@Injectable()
export class SnapshotEffects {
  loadSnapshotData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OverviewActions.loadSnapshot),
      switchMap(() =>
        combineLatest([
          this.overview.flags$.pipe(
            filter((flag) => !!flag?.snapshot),
            take(1)
          ),
          this.overview.serviceConfiguration$.pipe(
            filter((payload) => !!payload?.carrierCode),
            take(1)
          ),
          this.overview.aemErrorMessages$.pipe(
            filter((aemErrorMessages) => aemErrorMessages !== undefined),
            take(1)
          )
        ]).pipe(
          switchMap(([, payload, aemErrorMessages]) =>
            this.snapshot.getSnapshot(payload).pipe(
              map((content) =>
                OverviewActions.loadSnapshotSuccess({
                  snapshot: {
                    id: 'snapshot-content',
                    snapshotData: content
                  }
                })
              ),
              catchError((error: HttpErrorResponse) => {
                const message = aemErrorMessages.find((item) => {
                  return item.component === 'snapshot';
                });
                this.dataLayer.setErrorData(
                  error,
                  message.errorMessageDescription,
                  ErrorConstant.EVENT_NAME.replace(
                    PLACE_HOLDER,
                    SECTION_NAME.DASHBOARD
                  ),
                  ErrorConstant.TYPE.replace(
                    PLACE_HOLDER,
                    SECTION_NAME.DASHBOARD
                  )
                );
                return of(
                  OverviewActions.loadSnapshotFailure({
                    error: {
                      id: 'snapshot-content-error',
                      snapshotDataError: 'snapshot'
                    }
                  })
                );
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly snapshot: SnapshotService,
    private readonly overview: OverviewFacade,
    protected dataLayer: DataLayerAnalyticsService
  ) {}
}
